<div class="topsticky">
    <div class="fsBorder card" style="box-shadow: 0px 1px 16px #ddd;">
        <h4 class="text-muted"> Fare Summary </h4>
        <div class="bg-gradient-light px-2 pb-3">
            <div>
                <div class="row m-0 text-muted">
                    <ng-container *ngIf="isAdult(flight)">
                        <div class="col-md-12 col-lg-12 f-14 mb-2 mobile_nopad">
                            <div class="float-left">
                                <b>Adult ticket</b>
                            </div>
                            <div class="float-right customColor">
                                {{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.ADT?.TotalPrice | number:'1.1-2' }} X {{ adultCount }}
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 f-14 mb-2 mobile_nopad">
                            <div class="float-left customColor">
                                Base Fare
                            </div>
                            <div class="float-right customColor">
                                {{ flight.Price.Currency }}
                                {{ flight.Price.PassengerBreakup.ADT?.BasePrice | number:'1.1-2' }}
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 f-14 bbottom mb-3 mobile_nopad">
                            <div class="float-left customColor">
                                Taxes &amp; Fees
                            </div>
                            <div class="float-right customColor">
                                {{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.ADT?.Tax +  flight.Price.PriceBreakup?.AdvanceTax  | number:'1.1-2'  }}
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isChild(flight)">
                        <div class="col-md-12 col-lg-12 f-14 mb-2 mobile_nopad">
                            <div class="float-left">
                                <b>Child ticket</b>
                            </div>
                            <div class="float-right customColor">
                                {{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.CHD?.TotalPrice | number:'1.1-2'  }} X {{ childCount }}
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 f-14 mb-2 mobile_nopad">
                            <div class="float-left customColor">
                                Base Fare
                            </div>
                            <div class="float-right customColor">
                                {{ flight.Price.Currency }}
                                {{ flight.Price.PassengerBreakup.CHD?.BasePrice | number:'1.1-2'  }}
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 f-14 bbottom mb-3 mobile_nopad">
                            <div class="float-left customColor">
                                Taxes &amp; Fees
                            </div>
                            <div class="float-right customColor">
                                {{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.CHD?.Tax + flight.Price.PriceBreakup?.AdvanceTax | number:'1.1-2'  }}
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isInfant(flight)">
                        <div class="col-md-12 col-lg-12 f-14 mb-2 mobile_nopad">
                            <div class="float-left customColor">
                                <b>Infant ticket</b>
                            </div>
                            <div class="float-right customColor">
                                {{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.INF?.TotalPrice | number:'1.1-2'  }} X {{ infantCount }}
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 f-14 mb-2 mobile_nopad">
                            <div class="float-left customColor">
                                Base Fare
                            </div>
                            <div class="float-right customColor">
                                {{ flight.Price.Currency }}
                                {{ flight.Price.PassengerBreakup.INF?.BasePrice | number:'1.1-2'  }}
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 f-14 bbottom mb-3 mobile_nopad">
                            <div class="float-left customColor">
                                Taxes &amp; Fees
                            </div>
                            <div class="float-right customColor">
                                {{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.INF?.Tax + flight.Price.PriceBreakup?.AdvanceTax | number:'1.1-2'  }}
                            </div>
                        </div>
                    </ng-container>
                    <div class="col-md-12 col-lg-12 f-14 bbottom mb-3 mobile_nopad" *ngIf="flight.Price.PriceBreakup.TotalLostBaggageProtection">
                        <div class="float-left customColor">
                            Baggage Protection Fee
                        </div>
                        <div class="float-right customColor">
                            {{ flight.Price.Currency }} {{ flight.Price.PriceBreakup.TotalLostBaggageProtection | number:'1.1-2'  }}
                        </div>
                    </div>
                    <!-- <div class="col-md-12 col-lg-12 f-14 mb-3 mobile_nopad" *ngIf="flight.Price.PriceBreakup.AdvanceTax">
                        <div class="float-left" style="color: #082B3A !important;">
                            AIT
                        </div>
                        <div class="float-right customColor">
                            {{ flight.Price.Currency }} {{ flight.Price.PriceBreakup.AdvanceTax | number:'1.1-2'  }}
                        </div>
                    </div> -->
                    <div class="col-md-12 col-lg-12 f-18 mb-3 mobile_nopad">
                        <div class="float-left text-uppercase grand_tot">
                            Grand Total
                        </div>
                        <div class="float-right text-warning" style="color:#000 !important;">
                            {{ flight.Price.Currency }} {{ flight.Price.TotalDisplayFare | number:'1.1-2' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="impoinfo">
        <h4><i class="fal fa-info-circle"></i> Important Flight Information</h4>
        <p>Your flight is a combination of two one-way fares, each subject is to its own rules and restriction. <br>
            If one of your flights is changed or cancelled, it will not automatically alter the other flight. Changes to the other flight may incur a charge.</p>
        </div>
    
        <div class="impoinfo">
            <h4><i class="fal fa-plane-departure"></i> Departure</h4>
            <p>Tickets are non-refundable and non transferable. Name changes are not allowed.<br>
                Visit Singapore Airlines with baggage, for additional information about seats, bags and other restrictions. </p>
            </div>
    
            <div class="impoinfo">
                <h4><i class="fal fa-plane-arrival"></i> Return</h4>
                <p>Tickets are non-refundable and non transferable. Name changes are not allowed.<br>
                    Visit Singapore Airlines with baggage, for additional information about seats, bags and other restrictions. </p>
                </div>
     </div>           
